
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';
import { delGroupScheduling, delSchedulingShifts, getSchedulingList, getSchedulingShiftsUser, schedulingShiftsUser, startScheduling } from '@/api/groupScheduling';
import { groupPushScheduling } from '@/api/group';

import DialogSetShifts from '@/views/staff/components/setShifts.vue';
import DialogSetStaff from '@/views/staff/components/setStaff.vue';

@Component({
  name: 'dialogScheduling',
  components: {
    DialogSetShifts,
    DialogSetStaff
  }
})
export default class extends Vue {
  // 1
  @Prop({
    type: Number,
    default: 0,
    required: true
  })
  enterType!: Number;

  @Prop({
    type: Boolean,
    default: false
  })
  dialogVisible!: Boolean;

  @Prop({
    type: Object,
    default: () => {}
  })
  dept!: any;
  @Prop({
    type: Object,
    default: () => {}
  })
  groupData!: any;

  private listLoading=false;
  private currentPage=1;
  private pageSize=0;
  private tableData = []

  created() {
    this.getAuthGroup();
  }

  private loadMore() {
    this.currentPage = this.currentPage + 1;
    this.getAuthGroup();
  }
  private getAuthGroup() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      page: this.currentPage,
      group_push_id: this.groupData.group_push_id,
      group_push_name: this.groupData.group_push_name,
      is_group_push_list: 1,
      department_id: this.dept.dept_id,
      department_name: this.dept.name
    };
    getSchedulingList(params).then(res => {
      if (res.data && res.data.list && res.data.list.length > 0) {
        this.listLoading = false;
        this.pageSize = res.data.page_count;
        if (this.currentPage === 1) {
          this.tableData = res.data.list;
        } else {
          this.tableData = this.tableData.concat(res.data.list);
        }
        if (res.data.list.length === 1) {
          this.groupSchedulingId = res.data.list[0].id;
          if (!res.data.list[0].child || res.data.list[0].child.length < 1) {
            this.addShiftsHandle(res.data.list[0]);
          }
          if (res.data.list[0].child.length === 1 && parseInt(res.data.list[0].child[0].shifts_user_count) < 1) {
            this.settingStaffHandle(res.data.list[0].child[0], res.data.list[0]);
          }
        }
      } else {
        this.pageSize = 0;
        this.tableData = [];
      }
    }).catch(err => {
      this.pageSize = 0;
      this.tableData = [];
      this.listLoading = false;
      let msg = err.msg;
    });
  }
  private groupSchedulingId=''

  // 班次
  private itemData:any={}

  private shiftsOperate = 1

  private dialogSetStaffVisible = false;
  private dialogSetShiftsVisible=false;

  private shiftsClose(val:any) {
    this.dialogSetShiftsVisible = val;
  }
  private confirm() {
    this.getAuthGroup();
  }
  private addShiftsHandle(val:any) {
    this.itemData = val;
    this.itemData.groupId = val.id;
    this.shiftsOperate = 1;
    this.dialogSetShiftsVisible = true;
  }
  private editShiftsHandle(val:any, val2:any) {
    this.itemData = val;
    this.itemData.groupId = val2.id;
    this.shiftsOperate = 2;
    this.dialogSetShiftsVisible = true;
  }

  private deleteShiftsHandle(val:any) {
    this.itemData = val;
    this.showConfirmMsg('确认删除该班次吗?', 3);
  }
  // 设置人员
  private selectUserData:any = [];
  private settingStaffHandle(val: any, Prow:any) {
    this.itemData = val;
    this.itemData.dept_id = Prow.department_id;
    this.getSchedulingShiftsUser();
  }
  private getSchedulingShiftsUser() {
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    pamars.shifts_id = this.itemData.id;
    getSchedulingShiftsUser(pamars).then((res:any) => {
      if (res.data) {
        this.selectUserData = res.data.list;
      } else {
        this.selectUserData = [];
      }
      this.dialogSetStaffVisible = true;
    }).catch(err => {
      let msg = err.msg;
      this.selectUserData = [];
      this.dialogSetStaffVisible = true;
    });
  }
  private selectUser(val:any) {
    this.selectUserData = val;
    this.setUser(val);
  }

  private setUser(user:any) {
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    pamars.shifts_id = this.itemData.id;
    pamars.group_id = this.itemData.group_id;
    pamars.shifts_user = JSON.stringify(user);
    schedulingShiftsUser(pamars).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.getAuthGroup();
      this.dialogSetStaffVisible = false;
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private closeHandle(val: any) {
    this.dialogSetStaffVisible = val;
  }

  private showConfirmMsg(message: any, type:number) {
    this.$confirm(message, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.del(type);
    }).catch(() => {

    });
  }
  private del(type:number) {
    let pamars:any = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId
    };
    switch (type) {
      case 1:
        pamars.id = this.itemData.id;
        delGroupScheduling(pamars).then((res:any) => {
          this.showSuccessMsg(res.msg);
          this.getAuthGroup();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
      case 2:
        pamars.id = this.itemData.id;
        if (parseInt(this.itemData.state) === 1) {
          pamars.state = '0';
        } else {
          pamars.state = '1';
        }
        startScheduling(pamars).then((res:any) => {
          this.showSuccessMsg(res.msg);
          this.getAuthGroup();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
      case 3:
        pamars.shifts_id = this.itemData.id;
        delSchedulingShifts(pamars).then((res:any) => {
          this.showSuccessMsg(res.msg);
          this.getAuthGroup();
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
        break;
    }
  }

  private close() {
    this.$emit('close', false);
  }

  private handleDialogConfirm() {
    let pamars:any = {};
    pamars.company_id = UserModule.getCompanyId;
    pamars.user_id = UserModule.getUserId;
    pamars.id = this.groupData.group_push_id;
    pamars.group_scheduling_id = this.groupSchedulingId;

    groupPushScheduling(pamars).then((res:any) => {
      this.showSuccessMsg(res.msg);
      this.$emit('dialogSchedulingConfirm', res);
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
